import React from "react";
import { Outlet } from "react-router";
import AdminSignIn from "./AdminSignIn";
import { useAdminAuth } from './AdminAuthContext';
 
function AdminAuth() {
  const { isAuthenticated, login } = useAdminAuth();
 
  if (!isAuthenticated) {
    return (
      <AdminSignIn
        onLogin={login}
        title="Unaric Voice for Teams Admin"
      />
    );
  }
 
  return <Outlet />;
}
 

export default AdminAuth;
